export enum ErrorSeverity {
  Info = 100,
  Warning = 200,
  CriticalWarning = 300,
  Error = 400,
  Exception = 900
}
